/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.FameAdvantage {
    class FameAdvantageController extends Meevo.Components.CommonClasses.CommonControllerBase {
        static $inject = [
            'meevo.AppSettings',
            'meevo.plugins.fameAdvantage.fameAdvantageApi',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataConverterService',
            'meevo.components.common.DataExportService',
            '$translate',
            '$filter',
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected fameAdvantageApi: Meevo.Plugins.FameAdvantage.IFameAdvantageApi,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: Meevo.IContextParams,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected dataConverter: Meevo.Components.Common.IDataConverterService,
                    protected dataExportService: Meevo.Components.Common.IDataExportService,
                    protected $translate: ng.translate.ITranslateService,
                    protected $filter: ng.IFilterService
        ) {

            super(
                appSettings,
                fameAdvantageApi,
                modalService,
                identityService,
                loggingService,
                $scope,
                contextParams,
                $state,
                $rootScope,
                shortCutsService
            );

            this.shortCutGroup = {
                [Meevo.Model.MaintenanceFormState.Readonly]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_EDIT',
                    callback: () => {
                        this.context.edit();
                    }
                }]),
                [Meevo.Model.MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: () => {
                        this.context.save();
                    }

                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: () => {
                        this.context.cancel();
                    }
                }])
            };

            this.createContext();
        }

        public createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.INTEGRATION_FAMEADVANTAGE).then(() => {
                this.busyService.stop();
                this.context = new FameAdvantageContext(
                    this.appSettings,
                    this.fameAdvantageApi,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.$rootScope,
                    this.$state,
                    this.busyService,
                    this.dataConverter,
                    this.dataExportService,
                    this.$translate,
                    this.$filter,
                    this.$scope
                );
                super.createContext();
                this.context.activate();
            });
        }

    }

    angular.module('meevo.plugins.fameAdvantage')
        .controller('meevo.plugins.fameAdvantage.FameAdvantageController', FameAdvantageController);
}
